import { render, staticRenderFns } from "./my-pagination.vue?vue&type=template&id=0421c603&scoped=true&"
import script from "./my-pagination.vue?vue&type=script&lang=js&"
export * from "./my-pagination.vue?vue&type=script&lang=js&"
import style0 from "./my-pagination.vue?vue&type=style&index=0&id=0421c603&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0421c603",
  null
  
)

export default component.exports